import React from 'react';

import { domainTableHeadersLine } from './DomainTableHeader';

export type TextHeaderCellProps = Readonly<{
    testId: string;
    text: string;
}>;

export function TextHeaderCell(props: TextHeaderCellProps) {
    const { testId, text } = props;
    return (
        <th className={domainTableHeadersLine}>
            <span className={'tb-data-grid-header-text'} data-tb-test-id={testId}>
                {text}
            </span>
        </th>
    );
}
